import moment from "antd/node_modules/moment";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { sleep } from "../../common/Utils";

const convertItem = (it: any) => {
  let attrs: any[] = [];

  if (it.firstName !== it.pending.firstName) {
    attrs.push({
      type: "First Name",
      from: it.firstName,
      to: it.pending.firstName,
      result: true,
    });
  }

  if (it.lastName !== it.pending.lastName) {
    attrs.push({
      type: "Last Name",
      from: it.lastName,
      to: it.pending.lastName,
      result: true,
    });
  }

  if (it.grade !== it.pending.grade) {
    attrs.push({
      type: "Grade",
      from: it.grade,
      to: it.pending.grade,
      result: true,
    });
  }

  if (it.schoolId !== it.pending.orgId) {
    attrs.push({
      type: "School",
      from: it.school?.name,
      to: it.pending.org?.name,
      result: true,
    });
  }

  return {
    ...it,
    attrs,
  };
};

export class ChangeRequestStore {
  loading = false;
  childUpdates: any[] = [];

  filter: any = {
    page: 0,
    size: 20,

    // regionId: "",
    // divisionId: "",
    // communityId: "",
    // period: [undefined, undefined],
  };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {});
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: any[] = [undefined, undefined];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");

    this.filter = { page, size };

    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { page, size } = this.filter;
    const filter: any = {
      page,
      size,
    };

    return Api.user
      .childUpdates(filter)
      .then((res) => {
        runInAction(() => {
          this.data = {
            total: res.data.childUpdates.total,
            items: res.data.childUpdates.items.map((x) => convertItem(x)),
          };
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }

  @action
  confirm(input) {
    return Api.user.confirmUpdate(input).then(async () => {
      await sleep(3000);
      this.refresh();
    });
  }

  resultAll(attrs: any[], result: boolean) {
    let data: any = {};
    for (let attr of attrs) {
      if (attr.type === "First Name") {
        data = { ...data, firstName: result };
      } else if (attr.type === "Last Name") {
        data = { ...data, lastName: result };
      } else if (attr.type === "Grade") {
        data = { ...data, grade: result };
      } else if (attr.type === "School") {
        data = { ...data, school: result };
      }
    }
    return data;
  }
}

export const changeRequestStore = new ChangeRequestStore();
